__turbopack_context__.v({
  "container": "K7QP9W_container",
  "heading": "K7QP9W_heading",
  "list": "K7QP9W_list",
});
